import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";

export const SelectShippingCompany = ({selectedShippingCompany, setSelectedShippingCompany}) => {
    const [loading, setLoading] = useState(true);

    const [shippingCompanies, setShippingCompanies] = useState([]);

    useEffect(() => {
        getShippingCompanies();
    }, []);

    const getShippingCompanies = () => {
        setLoading(true);

        api.get(`/company?filters[0][type][contain]=shipping`).then(res => {
            setShippingCompanies(res.data.resources);
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    }

    return (
        <InputSelect
            loading={loading}
            label={`Transportadora`}
            options={createOptions(shippingCompanies, ['cnpj', 'trade_name'], 'id')} 
            value={selectedShippingCompany} 
            change={setSelectedShippingCompany}
        />
    );
}

export default SelectShippingCompany;